import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { ONE_THOUSAND_MILLISECONDS } from '@src/framework/editor/src/js/constants';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { getQuery } from 'sutils';

let isGotSlides = false;
let isNewEmptyPpt = false;

// 立即执行该函数，即在获取到数据之后，立即隐藏mobileHeader
const uiModelBindSDKListener = () => {
    eventBus.on(EventKeys.UI_MODEL_BIND_SDK, ({ slideCount, slides }) => {
        handleUIModelBindSDK(slideCount, slides);
    });
};
uiModelBindSDKListener();

/**
 * UIModelBindSDK回调函数，获取ui model数据后进行初始化
 */
const handleUIModelBindSDK = (slideCount, slides) => {
    isNewEmptyPpt = checkIsNewCreatedEmptyPpt(slideCount, slides);
    isGotSlides = true;
};

// 记录是否已经获取到slides
export const slidesStatus = () => isGotSlides;
export const isNewCreatedEmptyPpt = () => isNewEmptyPpt;

/**
 * 判断是否为新建的空的可编辑的PPT
 */
export const checkIsNewCreatedEmptyPpt = (slideCount, slides): boolean => {
    if (!window.clientVars) return false;

    // TODO: remove later
    const isCreateByAI = getQuery('openAiAssistant') === '1' || getQuery('AIGenerate') === '1';
    if (isCreateByAI) return false;

    const timeDiff = Math.abs(window.clientVars.metaCreateTime - window.clientVars.lastModifyTime);
    const isNewPpt = checkIsEmptyPpt(slideCount, slides);
    const { privilegeAttribute } = window.clientVars;
    const editable = privilegeAttribute?.can_edit;
    return (timeDiff <= ONE_THOUSAND_MILLISECONDS) && isNewPpt && editable;
};

/**
 * 判断是否为空的PPT
 */
export const checkIsEmptyPpt = (slideCount, slides) => {
    if (slideCount === 1 && slides && slides[0].children &&  slides[0].children.length === 2) {
        for (let index = 0; index < 2; index++) {
            const element = slides[0].children[index];
            if (!checkIsEmptyPlaceholder(element)) {
                return false;
            }
        }
        return true;
    }
    return false;
};

/**
 * 判断是否为空的占位符
 */
export const checkIsEmptyPlaceholder = element => element.isPlaceholder
    && element.type === UIModelType.SHAPE
    && element.paragraphList.length === 1
    && element.paragraphList[0].textRuns.length === 0;

/**
 * 用于单元测试导出
 */
export const testTable = {
    uiModelBindSDKListener,
    handleUIModelBindSDK,
};
